import { ContainerModule } from 'inversify';
import { QuestionBankService2, QuestionServiceSymbol } from './question-bank-service'
import * as Commands from './commands'

export const questionServiceModule = new ContainerModule((bind) => {
  bind(QuestionServiceSymbol).to(QuestionBankService2).inSingletonScope();
  bind(Commands.LoadQuestionsCommandHandler).toSelf();
});
